import { CustomEventWithDetail, html, on, View } from 'rune-ts';
import klass from './CreatorFilterButton.module.scss';
import { SellerTypeFilters } from '@services/database/mco/schema/public';
import { font } from '@services/MarppleShop/shared/typography';

export interface CreatorFilterButtonData {
  id?: number;
  name: SellerTypeFilters['name'];
  selected: boolean;
}

class CreatorFilterButtonClickEvent extends CustomEventWithDetail<CreatorFilterButtonData> {}

export class CreatorFilterButton extends View<CreatorFilterButtonData> {
  static ClickEvent = CreatorFilterButtonClickEvent;

  override template() {
    return html`<div
      class="${klass.creator_filter_button} ${font('14_medium')}"
      data-active="${this.data.selected}"
    >
      ${this.data.name}
    </div> `;
  }

  @on('click')
  onClickButton() {
    this.data.selected = !this.data.selected;
    this.element().dataset.active = `${this.data.selected}`;
    this.dispatchEvent(CreatorFilterButton.ClickEvent, { bubbles: true, detail: this.data });
  }
}
